import Cookies from 'js-cookie';
import JSZip from 'jszip'
import config from './config.json';
import moment from 'moment';

export const getApiBaseUrl = () => {
  const host = window.location.host;
  const domain = 'prosolve.com';
  const subDomain = 'events';
  const apiSubDomain = 'api';

  let apiBaseUrl;
  if (host.indexOf('localhost') > -1) {
    apiBaseUrl = `http://localhost:${config.port}/api`;
  } else {
    // detect env
    const parts = host.split('.');
    // Only qa/uat are real environments; any other segment before 'prosolve.com' means prod
    const envPart = parts[parts.length - 3];
    const env = ['qa', 'uat'].includes(envPart) ? `.${envPart}` : '';
    apiBaseUrl = `https://${apiSubDomain}.${subDomain}${env}.${domain}/api`
  }

  return apiBaseUrl;
}

export const addPlural = (val) => val > 1 ? 's' : '';

export const objectToQueryString = (obj) => {
  const objKeys = Object.keys(obj);
  return objKeys.length > 0 
    ? objKeys.map(key => key + '=' + obj[key]).join('&')
    : ''
} 

export const allowedClientSubdomains = ['star']

const allowedStandardDomains = ['go','localhost:3000']
const allAllowedSubDomains = [ ...allowedClientSubdomains, ...allowedStandardDomains ]

export const getClientSubdomain = () => {
  const originFull = window.origin;
  const splitVal = originFull.indexOf('https://') > -1 ? 'https://' : 'http://';
  const origin = originFull.split(splitVal)[1] || '';
 
  const parts = origin.split('.');
  const firstPart = parts[0];

  if (process.env.REACT_APP_SUBDOMAIN_ENV) {
    return process.env.REACT_APP_SUBDOMAIN_ENV
  }
  else if (allAllowedSubDomains.indexOf(firstPart) > -1) {
    return firstPart
  }
  else {
    return ''
  }
}

export const getIsProsolveSubdomain = () => {
  const clientSubdomain = getClientSubdomain()

  // Not great, would like a better solution using an inclusive only check, not an exclusive check
  const isStarSubdomain = (clientSubdomain === 'star')
  return !isStarSubdomain
}

export const getIsEventDelivered = ({ projectProgramComplete, deliveryNotes } = {}, isStarSubdomain) => {
  return isStarSubdomain ? Boolean(projectProgramComplete) : Boolean(deliveryNotes)
}

export const getEnv = () => {
  const host = window.location.host;

  // Always use qa if in a localhost environment
  if (host.indexOf('localhost') > -1) {
    return 'qa'
  } else {
    // detect env
    const parts = host.split('.');
    // Only qa/uat are real environments; any other segment before 'prosolve.com' means prod
    const envPart = parts[parts.length-3];
    const env = ['qa', 'uat'].includes(envPart) ? envPart : '';
    return env;
  }
}

export const checkHasEventTrainerPermissions = () => {
  const adminPermissionsCookies = Cookies.get('adminPermissions') || ''
  return (adminPermissionsCookies.indexOf('EVENTS_TRAINER') > -1)
}

export const checkHasEditEventPermissions = () => {
  const adminPermissionsCookies = Cookies.get('adminPermissions') || ''
  return (adminPermissionsCookies.indexOf('EVENTS_EDIT') > -1)
}

export const checkHasEditEventTemplatePermissions = () => {
  const adminPermissionsCookies = Cookies.get('adminPermissions') || ''
  return (adminPermissionsCookies.indexOf('EVENTS_TEMPLATE_EDIT') > -1)
}

export const checkHasReadJobsPermissions = () => {
  const adminPermissionsCookies = Cookies.get('adminPermissions') || ''
  return (adminPermissionsCookies.indexOf('JOBS_READ') > -1)
}

export const checkHasEditJobsPermissions = () => {
  const adminPermissionsCookies = Cookies.get('adminPermissions') || ''
  return (adminPermissionsCookies.indexOf('JOBS_EDIT') > -1)
}

// TODO: No longer used but temporarily keeping in code in case we want to go back to this behavior
// export const checkHasMarkEventDeliveredPermissions = () => {
//   const adminPermissionsCookies = Cookies.get('adminPermissions') || ''
//   return (adminPermissionsCookies.indexOf('EVENTS_CAN_MARK_EVENTS_AS_DELIVERED') > -1)
// }

export const copySvgToClipboardAsImage = async (svgElement) => {
    const svgText = new XMLSerializer().serializeToString(svgElement);
    const svgBlob = new Blob([svgText], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(svgBlob);

    const img = new Image();
    img.src = url;

    img.onload = async () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);

      canvas.toBlob(async (blob) => {
        try {
          await navigator.clipboard.write([
            new ClipboardItem({ [blob.type]: blob })
          ]);
          console.log('SVG copied as image!');
        } catch (err) {
          console.error('Failed to copy SVG as image:', err);
        }
      });
    };
  }

// Helper: download an array of urls. If a single url -> download directly.
// If multiple urls -> fetch each and bundle into a zip archive using JSZip.
// Falls back to opening direct urls if fetch fails.
export const downloadUrls = async (urls = [], zipFilename = 'files.zip') => {
  if (!urls || urls.length === 0) return

  const getDownloadData = (item, defaultFilename) => {
    const isObject = item && typeof item === 'object'
    const url = isObject ? item.url : item
    let filename = isObject ? item.filename : ''

    if (!filename) {
      filename = defaultFilename
      try {
        const u = new URL(url)
        const name = u.pathname.split('/').pop()
        if (name) filename = decodeURIComponent(name)
      } catch (e) {
        // ignore
      }
    }

    return { url, filename }
  }

  // Delay unneeded after testing over 100 files in the zip ...was overkill code via AI
  // const delay = (ms) => new Promise((res) => setTimeout(res, ms))

  // If only one file, keep previous behavior: fetch and download directly
  if (urls.length === 1) {
    const { url, filename } = getDownloadData(urls[0], 'file')
    if (!url) return

    try {
      const res = await fetch(url, { credentials: 'include' })
      if (!res.ok) throw new Error('Network response was not ok')
      const blob = await res.blob()

      const objectUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = objectUrl
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(objectUrl)
    } catch (err) {
      // fallback: open direct url
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      a.remove()
    }

    return
  }

  // Multiple files: zip them
  const zip = new JSZip()
  for (let i = 0; i < urls.length; i++) {
    const { url, filename } = getDownloadData(urls[i], `file-${i + 1}`)
    if (!url) continue
    // stagger requests slightly
    // if (i > 0) await delay(300)

    try {
      const res = await fetch(url, { credentials: 'include' })
      if (!res.ok) throw new Error('Network response was not ok')
      const blob = await res.blob()

      zip.file(filename, blob)
    } catch (err) {
      // If fetch fails for a file, add a small text file noting the failure and include the URL
      const noteName = `failed-to-download-${i + 1}.txt`
      zip.file(noteName, `Failed to fetch ${url}: ${err && err.message ? err.message : 'unknown error'}`)
    }
  }

  try {
    const content = await zip.generateAsync({ type: 'blob' })
    const a = document.createElement('a')
    a.style.display = 'none'
    const objectUrl = window.URL.createObjectURL(content)
    a.href = objectUrl
    a.download = zipFilename
    document.body.appendChild(a)
    a.click()
    a.remove()
    window.URL.revokeObjectURL(objectUrl)
  } catch (err) {
    // Zip generation failed - fallback: open each url in new tab
    for (let u of urls) {
      const { url } = getDownloadData(u, '')
      if (!url) continue

      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      a.remove()
      // small delay to reduce tab flooding
      // eslint-disable-next-line no-await-in-loop
      // await delay(200)
    }
  }
}

export const formatDateSpan = (startDate, endDate) => {

  const start = moment(startDate).format('MMM DD');
  const end = moment(endDate).format('MMM DD');
  const year = moment(endDate).format('YYYY');

  return `${start} - ${end}, ${year}`;
}

export const isStarConsultation = (eventData) => {
  return [
    'a1XPH000002TcS92AK',
    'a1XPH000002WTiT2AW',
    'a1XPH0000055jUf2AI',
    'a1XPH0000059gTN2AY',
    'a1XPH00000571PV2AY',
  ].includes(eventData.eventBlueprintId) 
}

export const getFileUploadImageTypesOnly = () => {
  return [
      // Images
      'image/jpeg',
      'image/png',
      'image/gif',
      'image/webp',
      'image/svg+xml',
  ]
}